const dir = require.context('../img/content/', true);
const imageIndex = {};

export function buildImageIndex(rows) {
  for (var i = 0; i < rows.length; i++) {
    const imageName = rows[i].Name;
    const imageFileName = rows[i].Filename;
    imageIndex[imageName] = imageFileName;
  }
}

export function getImageAsStyle(imageName, size="100%") {
  if (!imageIndex.hasOwnProperty(imageName)) {
    return null;
  }

  const url = dir(`./${imageIndex[imageName]}`);
  // NOTE to debug page/image pre-load performance
  // let url = dir(`./${imageIndex[imageName]}`);
  // url = `https://culture-staging.theblacktux.com${url}`;

  return {
    backgroundImage:`url('${url}')`,
    backgroundRepeat:'no-repeat',
    backgroundSize:size,
  }
}

export function getImageURL(imageName) {
  if (!imageIndex.hasOwnProperty(imageName)) {
    return null;
  }

  const url = dir(`./${imageIndex[imageName]}`);
  // NOTE to debug page/image pre-load performance
  // let url = dir(`./${imageIndex[imageName]}`);
  // url = `https://culture-staging.theblacktux.com${url}`;
  return url;
}
